let language = {
    CHECKOUT_SHIPPING_TITLE: "Shipping Address",
    CHECKOUT_SHIPPING_EMPTY: "No shipping address. Please add the shipping address first!",
    CHECKOUT_SHIPPING_BILLING: "Billing Address",
    CHECKOUT_SHIPPING_SELECT: "Select Address",
    CHECKOUT_SHIPPING_SAME_ADDRESS: "Billing address same as shipping address",
    CHECKOUT_SHIPPING_BILLING_EMPTY: "No billing address. Please add the billing address first!",
    CHECKOUT_SHIPPING_METHOD: "Shipping Method",
    CHECKOUT_SHIPPING_ISSUE_LOADING_TITLE: "Shipping Method Loading Issue",
    CHECKOUT_SHIPPING_ERROR_LOADING_TITLE: "Shipping Method Loading Error",
    CHECKOUT_SHIPPING_ISSUE_LOADING_CONTENT:"An issue occurred while loading shipping methods. Please refresh the page and try again. If the problem persists, feel free to contact our support team at {{supportmail}}.",
    CHECKOUT_SHIPPING_ISSUE_SHIPPING_METHOD_CONTENT: "Opps! An error occurred while getting order shipping methods,  you can click \"{{retryBtn}}\" to get it now or click \"{{cancelBtn}}\" to close the prompt.",
    CHECKOUT_SHIPPING_METHOD_ISSUE_TITLE: "Shipping Method Issue",
    CHECKOUT_SHIPPING_METHOD_ISSUE_BLACKLIST_ADDRESS: "The shipping address for this order is outside {{appName}}'s service coverage area. Please change the address to proceed this order. {{regions}}"

}


export { language }